import { ActivityIndicator, StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, normalize, spV } from "utils/normalise";

import { Colors } from "colors";
import { Image } from "react-native";
import ImageView from "../image";
import React from "react";
import VText from "components/VText";

const Buttons = ({
    text = "",
    onPress = () => {},
    isInverse = false,
    noBorder = true,
    fontSize = fp(14),
    disabled = false,
    textColor = "",
    loading = false,
    imageIcon = null,
    containerStyle = {},
    marginBottom = 0,
    iconStyle = {},
    textStyle = {},
    textTransform = "none",
}) => {
    return (
        <TouchableOpacity
            disabled={disabled}
            style={[
                styles.buttonContainer(isInverse, noBorder),
                marginBottom,
                {
                    cursor: disabled ? "not-allowed" : "pointer",
                    height: hp(40),
                },
                containerStyle,
            ]}
            onPress={loading ? () => {} : onPress}
        >
            {loading ? (
                <ActivityIndicator />
            ) : (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    {imageIcon !== null ? (
                        <View style={{ marginRight: 8 }}>
                            <Image
                                source={imageIcon}
                                resizeMode={ImageView.resizeMode.contain}
                                accessibilityLabel={`${text} Icon`}
                                style={[{ width: 24, height: 24 }, iconStyle]}
                            />
                        </View>
                    ) : null}
                    <VText
                        text={text}
                        style={[styles.buttontext(isInverse, textColor, textTransform, fontSize), textStyle]}
                    />
                </View>
            )}
        </TouchableOpacity>
    );
};

export default Buttons;

const styles = StyleSheet.create({
    buttonContainer: (isInverse, noBorder) => ({
        backgroundColor: isInverse ? "#FFFFFF" : "#212427",
        alignItems: "center",
        justifyContent: "center",
        borderWidth: 1,
        borderColor: noBorder ? "transparent" : Colors.black,
        padding: normalize(16),
    }),
    buttontext: (isInverse, textColor, textTransform, fontSize) => ({
        color: textColor ? textColor : isInverse ? "black" : "white",
        textTransform: textTransform,
        fontSize: fontSize,
        fontWeight: "350",
        fontFamily: "JosefinSans",
    }),
});
